// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @utilities
const {
    PROC_CONTRACTS,
    PROC_END,
    recordLink,
    recordPath,
} = require('utilities/tagging');
const {
    getAccountNameProduct,
    getAccountNameText,
    getAccountPath,
} = require('utilities/accountAddDocumentationTaggingHelper');

class AccountAddDocumentationSuccess extends React.Component {

    constructor(props) {
        super(props);

        this.handleSuccessButtonClick = this.handleSuccessButtonClick.bind(this);
    }

    componentDidMount() {
        const { immAccountAddDocumentation } = this.props;
        const subtype = getAccountNameText(immAccountAddDocumentation.get('subtype'));
        recordPath(getAccountPath(subtype), '', PROC_CONTRACTS, PROC_END, getAccountNameProduct(subtype));
    }

    componentWillUnmount() {
        const { resetUploadDocument } = this.props;
        resetUploadDocument();
    }

    handleSuccessButtonClick() {
        const { history, immAccountAddDocumentation } = this.props;
        const subtype = immAccountAddDocumentation.get('subtype');
        recordLink(getAccountPath(subtype), `volver a ${getAccountNameText(subtype)}`);
        history.push(`/myprofile/accounts/${immAccountAddDocumentation.get('accountId')}/movements`);
    }

    render() {
        const { immAccountAddDocumentation } = this.props;
        const title = formatText('accountUploadDocumentation-accountUploadDocumentation_successTitle');
        const alias = immAccountAddDocumentation.get('alias');
        const goBackButton = {
            label: formatText('accountUploadDocumentation-accountUploadDocumentation_backToAccount', [alias]),
        };

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardSuccess
                    mainButton={goBackButton}
                    onMainButtonClick={this.handleSuccessButtonClick}
                    successMessage={title}
                >
                    <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_successMessage" />
                </WizardSuccess>
            </div>
        );
    }
}

AccountAddDocumentationSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immAccountAddDocumentation: PropTypes.object.isRequired,
    resetUploadDocument: PropTypes.func.isRequired,
};

module.exports = withRouter(AccountAddDocumentationSuccess);
